import React from "react";

export type DateTimeStyle = "full" | "long" | "medium" | "short" | "hidden";

/**
 * Interface for TimeAndDateFormat.
 */
export interface ITimeAndDateFormatProps {
  /**
   * Time and date to be formatted.
   */
  timeAndDate: Date;

  /**
   * The date formatting style.
   */
  timeStyle: DateTimeStyle;

  /**
   * The time formatting style.
   */
  dateStyle: DateTimeStyle;
}

const TimeAndDateFormat: React.FC<ITimeAndDateFormatProps> = ({
  timeAndDate,
  timeStyle,
  dateStyle
}) => {
  const options: Intl.DateTimeFormatOptions = {};

  if (timeStyle !== "hidden") {
    // @ts-ignore
    options["timeStyle"] = timeStyle;
  }

  if (dateStyle !== "hidden") {
    // @ts-ignore
    options["dateStyle"] = dateStyle;
  }

  const formatter = new Intl.DateTimeFormat("en-nz", options);

  timeAndDate = timeAndDate ?? new Date();

  return <>{formatter.format(timeAndDate)}</>;

  //return <>{timeAndDate}</>;
};

export default TimeAndDateFormat;
